var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcShareMail = function SvgIcShareMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2A3642"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6 4H3.4l8.6 8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4 14 12 15.4 2 5.4v12.5c0 1.2.9 2.1 2.1 2.1h15.8c1.2 0 2.1-.9 2.1-2.1V5.4L13.4 14z"
  }))));
};
export { SvgIcShareMail as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCiAgICAgdmlld0JveD0iMCAwIDI0IDI0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNCAyNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KICAgIDxnPg0KICAgICAgICA8cG9seWdvbiBmaWxsPSIjMkEzNjQyIiBwb2ludHM9IjIwLjYsNCAzLjQsNCAxMiwxMi42Ii8+DQogICAgICAgIDxwYXRoIGZpbGw9IiMyQTM2NDIiIGQ9Ik0xMy40LDE0TDEyLDE1LjRMMiw1LjR2MTIuNUMyLDE5LjEsMi45LDIwLDQuMSwyMGgxNS44YzEuMiwwLDIuMS0wLjksMi4xLTIuMVY1LjRMMTMuNCwxNHoiLz4NCiAgICA8L2c+DQo8L3N2Zz4NCg==";